import { createRouter, createWebHistory } from 'vue-router'
function lazyLoad(view){
  return() => import(`@/views/${view}.vue`)
}
const routes = [
  {
    path: '/',
    name: 'Home',
    component: lazyLoad('HomeView')
  },
  {
    path: '/hE_Check',
    name: 'HE_Check',
    component: () => import(/* webpackChunkName: "HE_Check" */ '../components/Pages/AppHE_Check.vue')
  },
  {
    path: '/Landing',
    name: 'Landing',
    component: () => import(/* webpackChunkName: "Landing" */ '../components/Pages/Applanding.vue')
  },
  {
    path: '/search/:search_id',
    name: 'Search',
    component: () => import(/* webpackChunkName: "search" */ '../views/page/SearchView.vue'),
    props: true
  },
  {
    path: '/content/:Content_id',
    name: 'Content',
    component: () => import(/* webpackChunkName: "content" */ '../views/page/ContentView.vue'),
    props: true
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: () => import(/* webpackChunkName: "subscribe" */ '../views/user/SubscribeView.vue')
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/user/SignupView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/user/LoginView.vue')
  },
  {
    path: '/unsubscribes',
    name: 'Unsubscribes',
    component: () => import(/* webpackChunkName: "unsubscribes" */ '../views/user/UnsubscribesView.vue')
  },
  {
    path: '/art',
    name: 'Art',
    component: () => import(/* webpackChunkName: "art" */ '../views/category/ArtView.vue')
  },
  {
    path: '/comedy',
    name: 'Comedy',
    component: () => import(/* webpackChunkName: "comedy" */ '../views/category/ComedyView.vue')
  },
  {
    path: '/artist',
    name: 'Artist',
    component: () => import(/* webpackChunkName: "art" */ '../views/category/ArtistView.vue')
  },
  {
    path: '/artistContent',
    name: 'ArtistContent',
    component: () => import(/* webpackChunkName: "art" */ '../views/category/ArtistContentView.vue')
  }
  ,
  {
    path: '/seriesContent',
    name: 'SeriesContent',
    component: () => import(/* webpackChunkName: "art" */ '../views/category/SeriesContentView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
